// Meilisearch's facetDistribution only returns { field: { value: count } } — no
// human label for the field itself — so this static list plays the role
// `GET /search/filters` plays for the SPARQL-backed simple search, just keyed by
// a flattened field name (see scripts/index_search.py) instead of an RDF predicate
// URI. Keep this predicate list in sync with FACET_FIELDS in scripts/index_search.py
// and the fdp-entities index's filterableAttributes.
const facetFields = [
  {
    predicate: 'entityType',
    label: 'Type',
    description: 'The kind of entity in the FAIR Data Point, e.g. Catalog, Dataset or Distribution.',
    sortByCount: false,
  },
  {
    predicate: '_numberOfUniqueIndividualsBin',
    label: 'Number of Unique Individuals',
    description: 'The number of unique individuals covered by the Catalog or Dataset, grouped into ranges.',
    valueOrder: ['1 - 100', '101 - 1000', '1,001 - 10,000', '10,001 - 100,000', '100,001 - 1,000,000', '1,000,000+'],
    sortByCount: false,
  },
  {
    predicate: '_numberOfRecordsBin',
    label: 'Number of Records',
    description: 'The number of records (i.e. instnaces) covered by the Catalog or Dataset, grouped into ranges.',
    valueOrder: [
      '1 - 100',
      '101 - 1000',
      '1,001 - 10,000',
      '10,001 - 100,000',
      '100,001 - 1,000,000',
      '1,000,001 - 10,000,000',
      '10,000,001 - 100,000,000',
      '100,000,001 - 1,000,000,000',
      '1,000,000,001 - 10,000,000,000',
      '10,000,000,000+',
    ],
    sortByCount: false,
  },
  {
    predicate: 'interactiveVisualization',
    label: 'Interactive Visualization',
    description: 'Whether or not the Catalog or Dataset has an interactive visualization.',
  },
  {
    predicate: 'dataType',
    label: 'Data Type',
    description: 'The type of data contained in the Catalog or Dataset.',
  },
  {
    predicate: 'studyType',
    label: 'Study Type',
    description: 'The type of study the Catalog or Dataset originates from.',
  },
  {
    predicate: 'consentType',
    label: 'Consent Type',
    description: 'The type of consent obtained for using the data.',
  },
  {
    predicate: 'dataProvider',
    label: 'Data Provider',
    description: 'The organization that provided the data.',
  },
  {
    predicate: 'projectPartner',
    label: 'Project Partner',
    description: 'The project partner associated with the Catalog.',
  },
  {
    predicate: 'codingSystem',
    label: 'Coding System',
    description: 'The coding system used to classify the data, e.g. ICD-10 or SNOMED CT.',
  },
  {
    predicate: 'theme',
    label: 'Theme',
    description: 'The subject theme the Dataset relates to.',
  },
  {
    predicate: 'healthCategory',
    label: 'Health Category',
    description: 'The health category the Dataset relates to.',
  },
  {
    predicate: 'format',
    label: 'Format',
    description: 'The file format of the Distribution.',
  },
]

export const INDEX_UID = 'fdp-entities'

export default facetFields
